import config from '../../../config';
import links from '../../../config/links';

const { marketingAppHost, nextAppHost } = config;

export const getFooterNavigation = ({ redirectToNextApp }) => {
    return [
        {
            header: 'Explore',
            links: [
                { title: 'Cities', href: redirectToNextApp ? `${nextAppHost}/directory/cities/a` : '/cities' },
                { title: 'States', href: redirectToNextApp ? `${nextAppHost}/directory/states` : '/states' },
                { title: 'Countries', href: redirectToNextApp ? `${nextAppHost}/directory/countries` : '/countries' },
            ],
        },
        {
            header: 'Providers',
            links: [
                { title: 'Clubs', href: `${marketingAppHost}/pages/clubs` },
                { title: 'Academies', href: `${marketingAppHost}/pages/academies` },
                { title: 'High Schools', href: `${marketingAppHost}/pages/high-school` },
                { title: 'Colleges', href: `${marketingAppHost}/pages/college` },
                { title: 'Get in Touch', href: `${marketingAppHost}/pages/get-in-touch` },
            ],
        },
        {
            header: 'More',
            links: [
                { title: 'Developers', href: `${marketingAppHost}/pages/engage-api` },
                { title: 'News', href: `${marketingAppHost}/blogs/news` },
                { title: 'Press', href: `${marketingAppHost}/blogs/press` },
                { title: 'Shop', href: `${marketingAppHost}/collections/all` },
                { title: 'Careers', href: 'https://apply.workable.com/universal-tennis/' },
                { title: 'About Us', href: `${marketingAppHost}/pages/about-us` },
                { title: 'Foundation', href: `${marketingAppHost}/pages/foundation` },
                { title: 'Pro Insights', href: 'https://insights.utrsports.net/' },
            ],
        },
        {
            header: 'Support',
            links: [
                { title: 'Help Center', href: 'https://support.universaltennis.com/support/home' },
                { title: 'Privacy Policy', href: `${marketingAppHost}/policies/privacy-policy` },
                { title: 'Manage Cookies', href: '#manage_cookies' },
                { title: 'Do Not Sell or Share My Info', href: 'https://dataremovalrequest.utrsports.com/support/tickets/new' },
                { title: 'Terms & Conditions', href: `${marketingAppHost}/policies/terms-of-service` },
                { title: 'Guidelines', href: `${marketingAppHost}/pages/guidelines` },
                { title: 'Verified Events', href: `${marketingAppHost}/pages/verified` },
                { title: 'About UTR Rating', href: `${marketingAppHost}/pages/how-utr-works` },
                { title: 'About UTR-P Rating', href: `${marketingAppHost}/pages/how-utr-p-works` },
            ],
        },
    ];
};

export const socialLinks =
    [
        { title: 'Twitter', href: `https://twitter.com/${config.twitterAccount}`, imgSrc: '/footer/twitter-logo.svg', alt: 'twitter logo' },
        { title: 'Facebook', href: 'https://www.facebook.com/UTRSports', imgSrc: '/footer/facebook-logo.svg', alt: 'facebook logo' },
        { title: 'Instagram', href: 'https://www.instagram.com/utr_sports/', imgSrc: '/footer/instagram-logo.svg', alt: 'instagram logo' },
        { title: 'TikTok', href: 'https://www.tiktok.com/@utr_sports', imgSrc: '/footer/tiktok-logo.svg', alt: 'tiktok logo' },
        { title: 'Youtube', href: `https://www.youtube.com/c/myutr`, imgSrc: '/footer/youtube-logo.svg', alt: 'youtube logo' },
    ];

export const appStoreLinks =
    [
        { title: 'Apple Store', href: links.appStoreUrl, imgSrc: '/img/logos/app-store-badge.svg', alt: 'apple store logo' },
    ];
